import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { addQueueAccessoriesCount } from '../../../store/emarsys/action';

const useImpressionAccessories = (
  firstRef: React.RefObject<HTMLElement>,
  pageTitle: string = '',
  breadcrumbItems: IBreadcrumbs[],
  sku,
  skuPrice: string,
  sectionName: string = '',
  carModel: string[] = []
) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isAccessoriesActive = getFlagValue(FLAG_ENUM.EMARSYS_ACCESSORIES_DETAIL);
      if (isAuth && isFlagActive && isAccessoriesActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: 'aksesoris & spareparts detail page',
          page_title: pageTitle,
          page_url: window.location.href,
          menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toUpperCase() || '',
          menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase() || '',
          menu_cat_lvl3: breadcrumbItems?.[3]?.name?.toUpperCase() || '',
          sku,
          sku_price: skuPrice,
          section_name: sectionName,
        };

        if (carModel?.length > 0) {
          valuePageView.car_model = carModel?.join(', ');
        }

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueAccessoriesCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionAccessories;
